// extracted by mini-css-extract-plugin
export var aboveInput = "_n1-0";
export var actionButton = "_n1-5";
export var actionButtonContainer = "_n1-1";
export var actionIcon = "_n1-6";
export var aiInfoContainer = "_n1-2";
export var attachmentWrapper = "_n1-7";
export var bold = "_n1-3";
export var checkIcon = "_n1-8";
export var clickingRecipientBar = "_n1-11";
export var commentThreadSwitch = "_n1-a";
export var draftImage = "_n1-b";
export var draftImageContainer = "_n1-c";
export var draftImages = "_n1-e";
export var editButton = "_n1-g";
export var editor = "_n1-f";
export var editorContainer = "_n1-y";
export var editorErrorTooltipWrapper = "_n1-9";
export var headerDivider = "_n1-h";
export var icon = "_n1-i";
export var info = "_n1-j";
export var internal = "_n1-n";
export var internalDivider = "_n1-k";
export var internalMessage = "_n1-l";
export var messageInputCard = "_n1-m";
export var messageInputForm = "_n1-o";
export var messageInputFormInternal = "_n1-p";
export var options = "_n1-q";
export var publicMessageCustomer = "_n1-s";
export var publicMessageMerchant = "_n1-r";
export var removeImageButton = "_n1-d";
export var replyButtons = "_n1-t";
export var showSignatureButton = "_n1-u";
export var spinner = "_n1-v";
export var verticalButtonDivider = "_n1-4";
export var visibilitySelector = "_n1-w";
export var warning = "_n1-x";
export var wrappingText = "_n1-z";
export var writingInternalNoteTopBorder = "_n1-10";